/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';


const BillingPartyDropdown = ({
        field: { name },
        form: { setFieldValue },
        getBillingPartySelected,
        billingPartyId,
        orderModal,
        index,
        billingPartyBranchName,
        consignorName,
        consignorCode,
        consignorAddress,
        consignorGst,
        consigneeName,
        consigneeCode,
        consigneeAddress,
        consigneeGst,
        ...props
    }) => {
        
        const [billingParty, setBillingParty] = useState([])
        const [isLoading, setIsLoading] = useState(false)

        useEffect(() => {
            setIsLoading(true)
            let token = localStorage.getItem('isloggedIn')
            let userId = localStorage.getItem('userId')
            let customerNo = localStorage.getItem('customerNumber')
            let billingPartyIds = localStorage.getItem('billingpartIds').toString()

            const urlInput = `/billing_party?customerNumber=${customerNo}&userId=${userId}`
            const urlOrderModalInput = `/billing_party?customerNumber=${customerNo}&userId=${userId}&billingPartyIds=${billingPartyIds}`
            
            Axios.get(`${process.env.REACT_APP_MASTER_API}${orderModal ? urlOrderModalInput : urlInput}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                setBillingParty(response.data.resultSet)
                getBillingPartySelected && getBillingPartySelected(billingPartyId, response.data.resultSet)
                setIsLoading(false)
            }))
            .catch(error => {
                console.log(error);
                setIsLoading(false)
            })
                
        }, [])
    


    let options = []
    if (billingParty && billingParty.length > 0) {
        billingParty.map((object, index) => {
            let temp = {}
            temp.key = object.billingPartyId
            temp.text = `${object.billingPartyName} (${object.billingPartyCode})`
            temp.value = object.billingPartyId
            return options[index] = temp
        })
    }

    return (
        <Dropdown
            selection
            onChange={(value, data) => {
                setFieldValue(name, data.value);
                if (data.value) {
                    getBillingPartySelected && getBillingPartySelected(data.value)
                    setFieldValue(billingPartyBranchName, "")
                    setFieldValue(consignorName, "")
                    setFieldValue(consignorCode, "")
                    setFieldValue(consignorGst, "")
                    setFieldValue(consignorAddress, "")
                    setFieldValue(consigneeName, "")
                    setFieldValue(consigneeCode, "")
                    setFieldValue(consigneeGst, "")
                    setFieldValue(consigneeAddress, "")
                } else {
                    setFieldValue(billingPartyBranchName, "")
                    setFieldValue(consignorName, "")
                    setFieldValue(consignorCode, "")
                    setFieldValue(consignorGst, "")
                    setFieldValue(consignorAddress, "")
                    setFieldValue(consigneeName, "")
                    setFieldValue(consigneeCode, "")
                    setFieldValue(consigneeGst, "")
                    setFieldValue(consigneeAddress, "")
                }
            }}
            options={options}
            clearable
            loading={isLoading}
            {...props}
            style={{ width: '100%' }}
        />

    )
}

export default BillingPartyDropdown